export const appConfig = {
  appName: "mesh-retro",
  storagePrefix: "mesh-retro",
  description:
    "Peer-to-peer mesh: anonymous retro board. Mad/Sad/Glad + dot voting. ArUco mode for hands-free wall publish.",
  accentHex: "#7dd181",
  version: __APP_VERSION__,
  commit: __GIT_COMMIT__,
  repositoryUrl: "https://github.com/baditaflorin/mesh-retro",
  pagesUrl: "https://baditaflorin.github.io/mesh-retro/",
  signalingUrl:
    (import.meta.env.VITE_WEBRTC_SIGNALING as string | undefined) ?? "wss://turn.0docker.com/ws",
  turnTokenUrl:
    (import.meta.env.VITE_TURN_TOKEN_URL as string | undefined) ??
    "https://turn.0docker.com/credentials",
  paypalUrl: "https://www.paypal.com/paypalme/florinbadita",
} as const;
